import styled from "styled-components";

export const BodyMovies = styled.div`
background:#0F0E17;
`